<template>
  <div class="home-page">
    <ul class="home-nav-tab">
        <li class="p-pointer" v-for="(item,index) in navList" :key="index" :style="{backgroundImage:'url('+item.img+')'}" @mouseover="navBg=true;navBgIndex=index" @mouseleave="navBg=false;" @click="$router.push({path:'/lessons',query:{id:item.id,title:item.name}})">
            <div class="home-nav-title">{{item.name}}</div>
            <div v-show="navBgIndex === index" class="home-nav-an" :style="(navBg && navBgIndex === index) ? 'animation: nav-bg .2s forwards' : 'animation: nav-bg1 .2s forwards'"></div>
        </li>
    </ul>
    <div class="home-page-course">
      <div class="home-page-course-head">
        <h2>我要學習的課程<span></span><a class="p-pointer" @click="$router.push({path:'/myCourse',query:{title:'我要學習的課程'}})">更多<i class="el-icon-d-arrow-right"></i></a></h2>
      </div>
      <ul  class="home-page-course-con">
        <li v-for="item in myCourse" :key="item[0].id" @click="$router.push({path:'/home/lessons/study',query:{id:item[0].id,title:item[0].name}})">
          <lesson-card class="p-pointer" :data="item[0]"></lesson-card>
        </li>
      </ul>
    </div>
    <div class="home-page-course">
      <div class="home-page-course-head">
        <h2>部門培訓課程<span></span><a class="p-pointer" @click="$router.push({path:'/lessonsMore',query:{title:'部門培訓課程',type:2}})">更多<i class="el-icon-d-arrow-right"></i></a></h2>
      </div>
      <ul  class="home-page-course-con">
        <li v-for="item in publicData" :key="item.id" @click="$router.push({path:'/home/lessons/study',query:{id:item.id,title:item.name}})">
          <lesson-card class="p-pointer" :data="item"></lesson-card>
        </li>
        <li style="width: 100%;text-align: center;padding-bottom:20px;" v-show="publicData.length === 0">
          <empty title="暫無課程"></empty>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import lessonCard from '@p/components/lessonCard';
import empty from '@p/components/contentEmpty';
import { setTimeStr } from '@/utils';
import "@p/assets/css/animation.less";
export default {
  name:'homePage',
  data(){
    return {
      navBg:false,
      navBgIndex:'',
      navList:[],                     //分类模块数据
      myCourse:[],                    //我要学习的课程
      publicData:[],                  //部门培训课
    }
  },
  computed:{
    
  },
  created(){
    const { getMyCourse, getPublicCourse}=this.$store.state.home.homeKeep;  //保存首页数据
    if(getMyCourse){
      this.myCourse=getMyCourse
    }else{
      this.getMyCourse();
    }
    if(getPublicCourse){
      this.publicData=getPublicCourse
    }else{
      this.getPublicCourse();
    }
    if(this.$store.state.home.courseData.length>0)this.setCourseData(this.$store.state.home.courseData)
  },
  watch:{
      '$store.state.home.courseData':function(v){
          this.setCourseData(v)
      }
  },
  methods:{
    //我要学习课程
    async getMyCourse(){
      await this.$http.personal.getMyCourse({type:'study',page:1,page_size:5}).then(v=>{
        if(v.status === 200){
          this.myCourse=v.data.data.data;
          this.$store.commit('setHomeKeep',{'getMyCourse':v.data.data.data});
        }
      })
    },
    //公开课
    async getPublicCourse(){
      await this.$http.home.getDepartmentCourse({page:1,take:5}).then(v=>{
        if(v.status === 200){
          this.publicData=v.data.data.data;
          this.$store.commit('setHomeKeep',{'getPublicCourse':v.data.data.data});
        }
      }).catch(v=>{})
    },
    // 分类数据处理
    setCourseData(v){
        let arrData=[];
        let index = 0
        v.forEach((item) => {
            if(item.level == 1){
              index = (index >= 4) ? 1 : (index+1)
              arrData.push({...item,img:require('@p/assets/images/nav'+(index)+'.png'),})
            }
        });
        this.navList=arrData;
    },
    getTime(v){
      return setTimeStr(v)
    },
  },
  components:{
    lessonCard,empty
  }
}
</script>


<style lang="less" scoped>
@import "./index.less"; 
</style>
